<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2 d-flex justify-content-between">
                            <h5 class="mt-2">Brand logo</h5>
                            <button type="button" class="btn btn-success mb-2 mr-2" @click="showBrandLogo">
                                <i class="mdi mdi-upload mr-1"></i> Upload / Replace Logo
                            </button>
                        </div>
                        <div class="border rounded p-3 d-flex justify-content-center align-items-center" style="min-height: 90px; background: var(--c-bg, #f7f8fa)">
                            <BrandLogo :src="core.brand_logo_src" :fallback="logoFallback" alt="Brand logo" :height="60" @refetch="onLogoRefetch" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-2 d-flex justify-content-between">
                            <h5 class="mt-2">Roles with a marketing banner</h5>
                            <button type="button" class="btn btn-success mb-2 mr-2" @click="showMarketingBanner">
                                <i class="mdi mdi-plus mr-1"></i> Add Marketing Banner
                            </button>
                        </div>
                        <MarketingBannersTable />
                    </div>
                </div>
            </div>
        </div>
        <AddMarketingBannerModal v-if="show_modal" />
        <UploadBrandLogoModal v-if="show_modal_logo" />
    </div>
</template>

<script>
import MarketingBannersTable from "./tables/marketingBannersTable.vue";
import AddMarketingBannerModal from "./modals/addMarketingBannerModal.vue";
import UploadBrandLogoModal from "./modals/uploadBrandLogoModal.vue";
import BrandLogo from "@/components/shared/BrandLogo.vue";
import { adminComputed, adminMethods } from "@/state/helpers";

export default {
    components: { MarketingBannersTable, AddMarketingBannerModal, UploadBrandLogoModal, BrandLogo },
    data: () => ({
        show_modal: false,
        show_modal_logo: false,
        // Webpack 4 require() returns the hashed asset URL as a string value.
        logoFallback: require("@/assets/images/tfp_logo.png"),
    }),
    computed: {
        ...adminComputed,
    },
    methods: {
        ...adminMethods,
        onLogoRefetch() {
            this.loadCoreData().catch(() => {});
        },
        showBrandLogo() {
            this.show_modal_logo = true;
            this.$nextTick(() => {
                this.$bvModal.show("uploadBrandLogoModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "uploadBrandLogoModal") {
                        this.show_modal_logo = false;
                    }
                });
            });
        },
        showMarketingBanner() {
            this.show_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("addMarketingBannerModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "addMarketingBannerModal") {
                        this.show_modal = false;
                    }
                });
            });
        },
    },
    mounted() {},
};
</script>

<style></style>
